import { ReqType } from '../types'

class ApiRequest implements ReqType {
	method: ReqType['method']
	uri: ReqType['uri']
	body: ReqType['body']
	query: ReqType['query']
	headers: ReqType['headers']
	customHeaders: ReqType['customHeaders']
	accessToken: ReqType['accessToken']
	isRequiredToken: ReqType['isRequiredToken']
	baseURL: ReqType['baseURL']
	isRefresh: ReqType['isRefresh']

	constructor({
		method = '',
		uri = '',
		body = {},
		query = {},
		headers = {},
		customHeaders = {},
		accessToken = '',
		isRequiredToken = true,
		isRefresh = true,
		baseURL = '',
	} = {}) {
		/*
			허용 목록에 없는 메서드는 조용히 `get` 으로 떨어진다 — 요청이 실패하는 게 아니라
			**엉뚱한 곳으로 나간다.** 2026-09-14 에 `patch` 로 보내던 판매 시작/중지가 `GET` 으로
			나가 404 였고, 화면에서는 "전환이 안 된다"로만 보였다.
			이 프로젝트는 get·post·put·delete 만 쓴다. 갱신은 post 또는 put 이다.
		*/
		const paramMethod: ReqType['method'] = ['get', 'post', 'put', 'delete'].includes(
			method,
		)
			? (method as ReqType['method'])
			: 'get'

		this.method = paramMethod
		this.uri = uri
		this.body = body
		this.query = query
		this.headers = headers
		this.customHeaders = customHeaders
		this.accessToken = accessToken
		this.isRequiredToken = isRequiredToken
		this.isRefresh = isRefresh
		this.baseURL = baseURL
	}
}

export { ApiRequest }
